export const API_BASE_URL = 'https://api.medezweb.com/api/';
